import * as be from "react";
function H() {
  return H = Object.assign ? Object.assign.bind() : function(r) {
    for (var i = 1; i < arguments.length; i++) {
      var l = arguments[i];
      for (var s in l) Object.prototype.hasOwnProperty.call(l, s) && (r[s] = l[s]);
    }
    return r;
  }, H.apply(this, arguments);
}
const _e = ["children", "options"], se = ["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((r, i) => (r[i.toLowerCase()] = i, r), { class: "className", for: "htmlFor" }), ue = { amp: "&", apos: "'", gt: ">", lt: "<", nbsp: " ", quot: "“" }, Me = ["style", "script", "pre"], He = ["src", "href", "data", "formAction", "srcDoc", "action"], je = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, Ue = /mailto:/i, Ne = /\n{2,}$/, fe = /^(\s*>[\s\S]*?)(?=\n\n|$)/, Ie = /^ *> ?/gm, Be = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, We = /^ {2,}\n/, Ze = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, pe = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, de = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, Fe = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, Pe = /^(?:\n *)*\n/, qe = /\r\n?/g, De = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, Ge = /^\[\^([^\]]+)]/, Ve = /\f/g, Je = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, Ke = /^\s*?\[(x|\s)\]/, ge = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, ye = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, me = /^([^\n]+)\n *(=|-){3,} *\n/, ee = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, Qe = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, he = /^<!--[\s\S]*?(?:-->)/, Xe = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, te = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, Ye = /^\{.*\}$/, et = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, tt = /^<([^ >]+@[^ >]+)>/, nt = /^<([^ >]+:\/[^ >]+)>/, rt = /-([a-z])?/gi, ke = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, it = /^[^\n]+(?:  \n|\n{2,})/, lt = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, ot = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, ct = /^\[([^\]]*)\] ?\[([^\]]*)\]/, at = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, st = /\t/g, ut = /(^ *\||\| *$)/g, ft = /^ *:-+: *$/, pt = /^ *:-+ *$/, dt = /^ *-+: *$/, K = (r) => `(?=[\\s\\S]+?\\1${r ? "\\1" : ""})`, Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", gt = RegExp(`^([*_])\\1${K(1)}${Q}\\1\\1(?!\\1)`), yt = RegExp(`^([*_])${K(0)}${Q}\\1(?!\\1)`), mt = RegExp(`^(==)${K(0)}${Q}\\1`), ht = RegExp(`^(~~)${K(0)}${Q}\\1`), kt = /^(:[a-zA-Z0-9-_]+:)/, xt = /^\\([^0-9A-Za-z\s])/, vt = /\\([^0-9A-Za-z\s])/g, $t = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, bt = /^\n+/, Ot = /^([ \t]*)/, At = /(?:^|\n)( *)$/, oe = "(?:\\d+\\.)", ce = "(?:[*+-])";
function Oe(r) {
  return "( *)(" + (r === 1 ? oe : ce) + ") +";
}
const Ae = Oe(1), Ce = Oe(2);
function Se(r) {
  return RegExp("^" + (r === 1 ? Ae : Ce));
}
const Ct = Se(1), St = Se(2);
function Te(r) {
  return RegExp("^" + (r === 1 ? Ae : Ce) + "[^\\n]*(?:\\n(?!\\1" + (r === 1 ? oe : ce) + " )[^\\n]*)*(\\n|$)", "gm");
}
const Tt = Te(1), zt = Te(2);
function ze(r) {
  const i = r === 1 ? oe : ce;
  return RegExp("^( *)(" + i + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + i + " (?!" + i + " ))\\n*|\\s*\\n*$)");
}
const Ee = ze(1), Le = ze(2);
function xe(r, i) {
  const l = i === 1, s = l ? Ee : Le, d = l ? Tt : zt, m = l ? Ct : St;
  return { t: (p) => m.test(p), o: I(function(p, c) {
    const f = At.exec(c.prevCapture);
    return f && (c.list || !c.inline && !c.simple) ? s.exec(p = f[1] + p) : null;
  }), i: 1, u(p, c, f) {
    const h = l ? +p[2] : void 0, O = p[0].replace(Ne, `
`).match(d);
    let A = !1;
    return { items: O.map(function(L, Z) {
      const F = m.exec(L)[0].length, P = RegExp("^ {1," + F + "}", "gm"), j = L.replace(P, "").replace(m, ""), e = Z === O.length - 1, n = j.indexOf(`

`) !== -1 || e && A;
      A = n;
      const t = f.inline, a = f.list;
      let o;
      f.list = !0, n ? (f.inline = !1, o = W(j) + `

`) : (f.inline = !0, o = W(j));
      const u = c(o, f);
      return f.inline = t, f.list = a, u;
    }), ordered: l, start: h };
  }, l: (p, c, f) => r(p.ordered ? "ol" : "ul", { key: f.key, start: p.type === "20" ? p.start : void 0 }, p.items.map(function(h, O) {
    return r("li", { key: O }, c(h, f));
  })) };
}
const Et = RegExp(`^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['"]([\\s\\S]*?)['"])?\\s*\\)`), Lt = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function W(r) {
  let i = r.length;
  for (; i > 0 && r[i - 1] <= " "; ) i--;
  return r.slice(0, i);
}
function V(r, i) {
  return r.startsWith(i);
}
function wt(r, i, l) {
  if (Array.isArray(l)) {
    for (let s = 0; s < l.length; s++) if (V(r, l[s])) return !0;
    return !1;
  }
  return l(r, i);
}
function B(r) {
  return r.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function Rt(r) {
  return dt.test(r) ? "right" : ft.test(r) ? "center" : pt.test(r) ? "left" : null;
}
function ve(r, i, l, s) {
  const d = l.inTable;
  l.inTable = !0;
  let m = [[]], p = "";
  function c() {
    if (!p) return;
    const f = m[m.length - 1];
    f.push.apply(f, i(p, l)), p = "";
  }
  return r.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((f, h, O) => {
    f.trim() === "|" && (c(), s) ? h !== 0 && h !== O.length - 1 && m.push([]) : p += f;
  }), c(), l.inTable = d, m;
}
function _t(r, i, l) {
  l.inline = !0;
  const s = r[2] ? r[2].replace(ut, "").split("|").map(Rt) : [], d = r[3] ? (function(p, c, f) {
    return p.trim().split(`
`).map(function(h) {
      return ve(h, c, f, !0);
    });
  })(r[3], i, l) : [], m = ve(r[1], i, l, !!d.length);
  return l.inline = !1, d.length ? { align: s, cells: d, header: m, type: "25" } : { children: m, type: "21" };
}
function $e(r, i) {
  return r.align[i] == null ? {} : { textAlign: r.align[i] };
}
function I(r) {
  return r.inline = 1, r;
}
function z(r) {
  return I(function(i, l) {
    return l.inline ? r.exec(i) : null;
  });
}
function E(r) {
  return I(function(i, l) {
    return l.inline || l.simple ? r.exec(i) : null;
  });
}
function T(r) {
  return function(i, l) {
    return l.inline || l.simple ? null : r.exec(i);
  };
}
function G(r) {
  return I(function(i) {
    return r.exec(i);
  });
}
const Mt = /(javascript|vbscript|data(?!:image)):/i;
function Ht(r) {
  try {
    const i = decodeURIComponent(r).replace(/[^A-Za-z0-9/:]/g, "");
    if (Mt.test(i)) return null;
  } catch {
    return null;
  }
  return r;
}
function S(r) {
  return r && r.replace(vt, "$1");
}
function J(r, i, l) {
  const s = l.inline || !1, d = l.simple || !1;
  l.inline = !0, l.simple = !0;
  const m = r(i, l);
  return l.inline = s, l.simple = d, m;
}
function jt(r, i, l) {
  const s = l.inline || !1, d = l.simple || !1;
  l.inline = !1, l.simple = !0;
  const m = r(i, l);
  return l.inline = s, l.simple = d, m;
}
function Ut(r, i, l) {
  const s = l.inline || !1;
  l.inline = !1;
  const d = r(i, l);
  return l.inline = s, d;
}
const ne = (r, i, l) => ({ children: J(i, r[2], l) });
function re() {
  return {};
}
function ie() {
  return null;
}
function Nt(...r) {
  return r.filter(Boolean).join(" ");
}
function le(r, i, l) {
  let s = r;
  const d = i.split(".");
  for (; d.length && (s = s[d[0]], s !== void 0); ) d.shift();
  return s || l;
}
function It(r = "", i = {}) {
  i.overrides = i.overrides || {}, i.namedCodesToUnicode = i.namedCodesToUnicode ? H({}, ue, i.namedCodesToUnicode) : ue;
  const l = i.slugify || B, s = i.sanitizer || Ht, d = i.createElement || be.createElement, m = [fe, pe, de, i.enforceAtxHeadings ? ye : ge, me, ke, Ee, Le], p = [...m, it, ee, he, te];
  function c(e, n, ...t) {
    const a = le(i.overrides, e + ".props", {});
    return d((function(o, u) {
      const g = le(u, o);
      return g ? typeof g == "function" || typeof g == "object" && "render" in g ? g : le(u, o + ".component", o) : o;
    })(e, i.overrides), H({}, n, a, { className: Nt(n?.className, a.className) || void 0 }), ...t);
  }
  function f(e) {
    e = e.replace(Je, "");
    let n = !1;
    i.forceInline ? n = !0 : i.forceBlock || (n = at.test(e) === !1);
    const t = F(Z(n ? e : W(e).replace(bt, "") + `

`, { inline: n }));
    for (; typeof t[t.length - 1] == "string" && !t[t.length - 1].trim(); ) t.pop();
    if (i.wrapper === null) return t;
    const a = i.wrapper || (n ? "span" : "div");
    let o;
    if (t.length > 1 || i.forceWrapper) o = t;
    else {
      if (t.length === 1) return o = t[0], typeof o == "string" ? c("span", { key: "outer" }, o) : o;
      o = null;
    }
    return d(a, { key: "outer" }, o);
  }
  function h(e, n) {
    if (!n || !n.trim()) return null;
    const t = n.match(je);
    return t ? t.reduce(function(a, o) {
      const u = o.indexOf("=");
      if (u !== -1) {
        const g = (function(y) {
          return y.indexOf("-") !== -1 && y.match(Xe) === null && (y = y.replace(rt, function(b, v) {
            return v.toUpperCase();
          })), y;
        })(o.slice(0, u)).trim(), k = (function(y) {
          const b = y[0];
          return (b === '"' || b === "'") && y.length >= 2 && y[y.length - 1] === b ? y.slice(1, -1) : y;
        })(o.slice(u + 1).trim()), x = se[g] || g;
        if (x === "ref") return a;
        const $ = a[x] = (function(y, b, v, ae) {
          return b === "style" ? (function(U) {
            const w = [];
            let R = "", _ = !1, q = !1, X = "";
            if (!U) return w;
            for (let M = 0; M < U.length; M++) {
              const C = U[M];
              if (C !== '"' && C !== "'" || _ || (q ? C === X && (q = !1, X = "") : (q = !0, X = C)), C === "(" && R.endsWith("url") ? _ = !0 : C === ")" && _ && (_ = !1), C !== ";" || q || _) R += C;
              else {
                const N = R.trim();
                if (N) {
                  const Y = N.indexOf(":");
                  if (Y > 0) {
                    const we = N.slice(0, Y).trim(), Re = N.slice(Y + 1).trim();
                    w.push([we, Re]);
                  }
                }
                R = "";
              }
            }
            const D = R.trim();
            if (D) {
              const M = D.indexOf(":");
              if (M > 0) {
                const C = D.slice(0, M).trim(), N = D.slice(M + 1).trim();
                w.push([C, N]);
              }
            }
            return w;
          })(v).reduce(function(U, [w, R]) {
            return U[w.replace(/(-[a-z])/g, (_) => _[1].toUpperCase())] = ae(R, y, w), U;
          }, {}) : He.indexOf(b) !== -1 ? ae(S(v), y, b) : (v.match(Ye) && (v = S(v.slice(1, v.length - 1))), v === "true" || v !== "false" && v);
        })(e, g, k, s);
        typeof $ == "string" && (ee.test($) || te.test($)) && (a[x] = f($.trim()));
      } else o !== "style" && (a[se[o] || o] = !0);
      return a;
    }, {}) : null;
  }
  const O = [], A = {}, L = { 0: { t: [">"], o: T(fe), i: 1, u(e, n, t) {
    const [, a, o] = e[0].replace(Ie, "").match(Be);
    return { alert: a, children: n(o, t) };
  }, l(e, n, t) {
    const a = { key: t.key };
    return e.alert && (a.className = "markdown-alert-" + l(e.alert.toLowerCase(), B), e.children.unshift({ attrs: {}, children: [{ type: "27", text: e.alert }], noInnerParse: !0, type: "11", tag: "header" })), c("blockquote", a, n(e.children, t));
  } }, 1: { o: G(We), i: 1, u: re, l: (e, n, t) => c("br", { key: t.key }) }, 2: { t: (e) => {
    const n = e[0];
    return n === "-" || n === "*" || n === "_";
  }, o: T(Ze), i: 1, u: re, l: (e, n, t) => c("hr", { key: t.key }) }, 3: { t: ["    "], o: T(de), i: 0, u: (e) => ({ lang: void 0, text: S(W(e[0].replace(/^ {4}/gm, ""))) }), l: (e, n, t) => c("pre", { key: t.key }, c("code", H({}, e.attrs, { className: e.lang ? "lang-" + e.lang : "" }), e.text)) }, 4: { t: ["```", "~~~"], o: T(pe), i: 0, u: (e) => ({ attrs: h("code", e[3] || ""), lang: e[2] || void 0, text: e[4], type: "3" }) }, 5: { t: ["`"], o: E(Fe), i: 3, u: (e) => ({ text: S(e[2]) }), l: (e, n, t) => c("code", { key: t.key }, e.text) }, 6: { t: ["[^"], o: T(De), i: 0, u: (e) => (O.push({ footnote: e[2], identifier: e[1] }), {}), l: ie }, 7: { t: ["[^"], o: z(Ge), i: 1, u: (e) => ({ target: "#" + l(e[1], B), text: e[1] }), l: (e, n, t) => c("a", { key: t.key, href: s(e.target, "a", "href") }, c("sup", { key: t.key }, e.text)) }, 8: { t: ["[ ]", "[x]"], o: z(Ke), i: 1, u: (e) => ({ completed: e[1].toLowerCase() === "x" }), l: (e, n, t) => c("input", { checked: e.completed, key: t.key, readOnly: !0, type: "checkbox" }) }, 9: { t: ["#"], o: T(i.enforceAtxHeadings ? ye : ge), i: 1, u: (e, n, t) => ({ children: J(n, e[2], t), id: l(e[2], B), level: e[1].length }), l: (e, n, t) => c("h" + e.level, { id: e.id, key: t.key }, n(e.children, t)) }, 10: { o: T(me), i: 0, u: (e, n, t) => ({ children: J(n, e[1], t), level: e[2] === "=" ? 1 : 2, type: "9" }) }, 11: { t: ["<"], o: G(ee), i: 1, u(e, n, t) {
    const [, a] = e[3].match(Ot), o = RegExp("^" + a, "gm"), u = e[3].replace(o, ""), g = (k = u, p.some((v) => v.test(k)) ? Ut : J);
    var k;
    const x = e[1].toLowerCase(), $ = Me.indexOf(x) !== -1, y = ($ ? x : e[1]).trim(), b = { attrs: h(y, e[2]), noInnerParse: $, tag: y };
    if (t.inAnchor = t.inAnchor || x === "a", $) b.text = e[3];
    else {
      const v = t.inHTML;
      t.inHTML = !0, b.children = g(n, u, t), t.inHTML = v;
    }
    return t.inAnchor = !1, b;
  }, l: (e, n, t) => c(e.tag, H({ key: t.key }, e.attrs), e.text || (e.children ? n(e.children, t) : "")) }, 13: { t: ["<"], o: G(te), i: 1, u(e) {
    const n = e[1].trim();
    return { attrs: h(n, e[2] || ""), tag: n };
  }, l: (e, n, t) => c(e.tag, H({}, e.attrs, { key: t.key })) }, 12: { t: ["<!--"], o: G(he), i: 1, u: () => ({}), l: ie }, 14: { t: ["!["], o: E(Lt), i: 1, u: (e) => ({ alt: S(e[1]), target: S(e[2]), title: S(e[3]) }), l: (e, n, t) => c("img", { key: t.key, alt: e.alt || void 0, title: e.title || void 0, src: s(e.target, "img", "src") }) }, 15: { t: ["["], o: z(Et), i: 3, u: (e, n, t) => ({ children: jt(n, e[1], t), target: S(e[2]), title: S(e[3]) }), l: (e, n, t) => c("a", { key: t.key, href: s(e.target, "a", "href"), title: e.title }, n(e.children, t)) }, 16: { t: ["<"], o: z(nt), i: 0, u: (e) => ({ children: [{ text: e[1], type: "27" }], target: e[1], type: "15" }) }, 17: { t: (e, n) => !n.inAnchor && !i.disableAutoLink && (V(e, "http://") || V(e, "https://")), o: z(et), i: 0, u: (e) => ({ children: [{ text: e[1], type: "27" }], target: e[1], title: void 0, type: "15" }) }, 18: { t: ["<"], o: z(tt), i: 0, u(e) {
    let n = e[1], t = e[1];
    return Ue.test(t) || (t = "mailto:" + t), { children: [{ text: n.replace("mailto:", ""), type: "27" }], target: t, type: "15" };
  } }, 20: xe(c, 1), 33: xe(c, 2), 19: { o: T(Pe), i: 3, u: re, l: () => `
` }, 21: { o: I(function(e, n) {
    if (n.inline || n.simple || n.inHTML && e.indexOf(`

`) === -1 && n.prevCapture.indexOf(`

`) === -1) return null;
    let t = "";
    e.split(`
`).every((o) => (o += `
`, !m.some((u) => u.test(o)) && (t += o, !!o.trim())));
    const a = W(t);
    return a === "" ? null : [t, , a];
  }), i: 3, u: ne, l: (e, n, t) => c("p", { key: t.key }, n(e.children, t)) }, 22: { t: ["["], o: z(lt), i: 0, u: (e) => (A[e[1]] = { target: e[2], title: e[4] }, {}), l: ie }, 23: { t: ["!["], o: E(ot), i: 0, u: (e) => ({ alt: e[1] ? S(e[1]) : void 0, ref: e[2] }), l: (e, n, t) => A[e.ref] ? c("img", { key: t.key, alt: e.alt, src: s(A[e.ref].target, "img", "src"), title: A[e.ref].title }) : null }, 24: { t: (e) => e[0] === "[" && e.indexOf("](") === -1, o: z(ct), i: 0, u: (e, n, t) => ({ children: n(e[1], t), fallbackChildren: e[0], ref: e[2] }), l: (e, n, t) => A[e.ref] ? c("a", { key: t.key, href: s(A[e.ref].target, "a", "href"), title: A[e.ref].title }, n(e.children, t)) : c("span", { key: t.key }, e.fallbackChildren) }, 25: { t: ["|"], o: T(ke), i: 1, u: _t, l(e, n, t) {
    const a = e;
    return c("table", { key: t.key }, c("thead", null, c("tr", null, a.header.map(function(o, u) {
      return c("th", { key: u, style: $e(a, u) }, n(o, t));
    }))), c("tbody", null, a.cells.map(function(o, u) {
      return c("tr", { key: u }, o.map(function(g, k) {
        return c("td", { key: k, style: $e(a, k) }, n(g, t));
      }));
    })));
  } }, 27: { o: I(function(e, n) {
    let t;
    return V(e, ":") && (t = kt.exec(e)), t || $t.exec(e);
  }), i: 4, u(e) {
    const n = e[0];
    return { text: n.indexOf("&") === -1 ? n : n.replace(Qe, (t, a) => i.namedCodesToUnicode[a] || t) };
  }, l: (e) => e.text }, 28: { t: ["**", "__"], o: E(gt), i: 2, u: (e, n, t) => ({ children: n(e[2], t) }), l: (e, n, t) => c("strong", { key: t.key }, n(e.children, t)) }, 29: { t: (e) => {
    const n = e[0];
    return (n === "*" || n === "_") && e[1] !== n;
  }, o: E(yt), i: 3, u: (e, n, t) => ({ children: n(e[2], t) }), l: (e, n, t) => c("em", { key: t.key }, n(e.children, t)) }, 30: { t: ["\\"], o: E(xt), i: 1, u: (e) => ({ text: e[1], type: "27" }) }, 31: { t: ["=="], o: E(mt), i: 3, u: ne, l: (e, n, t) => c("mark", { key: t.key }, n(e.children, t)) }, 32: { t: ["~~"], o: E(ht), i: 3, u: ne, l: (e, n, t) => c("del", { key: t.key }, n(e.children, t)) } };
  i.disableParsingRawHTML === !0 && (delete L[11], delete L[13]);
  const Z = (function(e) {
    var n = Object.keys(e);
    function t(a, o) {
      var u = [];
      if (o.prevCapture = o.prevCapture || "", a.trim()) for (; a; ) for (var g = 0; g < n.length; ) {
        var k = n[g], x = e[k];
        if (!x.t || wt(a, o, x.t)) {
          var $ = x.o(a, o);
          if ($ && $[0]) {
            a = a.substring($[0].length);
            var y = x.u($, t, o);
            o.prevCapture += $[0], y.type || (y.type = k), u.push(y);
            break;
          }
          g++;
        } else g++;
      }
      return o.prevCapture = "", u;
    }
    return n.sort(function(a, o) {
      return e[a].i - e[o].i || (a < o ? -1 : 1);
    }), function(a, o) {
      return t((function(u) {
        return u.replace(qe, `
`).replace(Ve, "").replace(st, "    ");
      })(a), o);
    };
  })(L), F = (P = /* @__PURE__ */ (function(e, n) {
    return function(t, a, o) {
      const u = e[t.type].l;
      return n ? n(() => u(t, a, o), t, a, o) : u(t, a, o);
    };
  })(L, i.renderRule), function e(n, t = {}) {
    if (Array.isArray(n)) {
      const a = t.key, o = [];
      let u = !1;
      for (let g = 0; g < n.length; g++) {
        t.key = g;
        const k = e(n[g], t), x = typeof k == "string";
        x && u ? o[o.length - 1] += k : k !== null && o.push(k), u = x;
      }
      return t.key = a, o;
    }
    return P(n, e, t);
  });
  var P;
  const j = f(r);
  return O.length ? c("div", null, j, c("footer", { key: "footer" }, O.map(function(e) {
    return c("div", { id: l(e.identifier, B), key: e.identifier }, e.identifier, F(Z(e.footnote, { inline: !0 })));
  }))) : j;
}
const Bt = (r) => {
  let { children: i = "", options: l } = r, s = (function(d, m) {
    if (d == null) return {};
    var p, c, f = {}, h = Object.keys(d);
    for (c = 0; c < h.length; c++) m.indexOf(p = h[c]) >= 0 || (f[p] = d[p]);
    return f;
  })(r, _e);
  return be.cloneElement(It(i, l), s);
};
export {
  It as compiler,
  Bt as default,
  Ht as sanitizer,
  B as slugify
};
//# sourceMappingURL=index.es259.js.map
